<template>
  <div class="challenge-action-association container-fluid padding-left-0Perc margin-Top-Bottom-1Point5Perc">
    <div class="admin-Panel-Padding">
      <div class="row">
        <div class="col-md-4 col-lg-4 height300 padding-left-0Perc">
          <div class="form-group margin-bottom-1Perc">
            <div class="icon-addon addon-lg">
              <input type="text" ref="input" class="form-control background-gray border-rounded" autocomplete="off" id="search" v-on:focus="increaseComponentHeight($event)" v-on:blur="decreaseComponentHeight($event)"/>
              <label class="glyphicon glyphicon-search"></label>
              <typeahead v-model="selectedActionObj" target="#search" :data="getActiveGlobalActionList" id="typeheadSearch" item-key="CustomActionName" :limit="10" append-to-body :open-on-empty="true"></typeahead>
            </div>
          </div>
          <div class="font-size-12px">
            <span>Total Active Actions: <b>{{activeActionCount}}</b></span>
            <span> | </span>
            <span class="text-color-blue cursor-pointer" @click="performUserAction($event, 'open-action-library-page', null)"><u>+Create New</u></span>
          </div>
        </div>
        <div class="col-md-1 col-lg-1 padding-left-0Perc">
          <button type="button" class="btn black-border custom-btn white-BG col-xs-12 col-sm-12 col-md-12 col-lg-12" @click="performUserAction($event, 'add', null)">Go</button>
        </div>
        <div class="col-md-7 col-lg-7 padding-left-0Perc border-left-grey">
          <div class="row vertical-align padding-top-2perc margin-left-15px padding-bottom-2perc cursor-pointer" v-if="challengeActions.length === 0">
            <div class="col-md-12 col-lg-12">
              <b>No Associated Actions Found.</b>
            </div>
          </div>
          <div class="row vertical-align padding-top-2perc margin-left-15px padding-bottom-2perc cursor-pointer" v-if="notActiveAssocitedRowsFound">
            <div class="col-md-12 col-lg-12 font-size-12px text-align-left padding-left-0Perc margin-bottom-1Perc">
              <b>* Red Row = Either they got Deleted Or Not Active Action Found.</b>
            </div>
          </div>
          <div class="drag">
              <draggable :challengeActionValue="challengeActions" v-model="challengeActionValue">
                <transition-group>
                  <div v-for="(actionObj, index) in challengeActions" :key="actionObj.ActionLibraryId" :actionObj="actionObj" class="row min-height-25px vertical-align padding-top-2perc margin-left-15px padding-bottom-2perc cursor-pointer bottom-dotted-border">
                    <div class="col-md-2 col-lg-2">
                      <img src= "../../../assets/images/reorder.svg" class="cursor-pointer img-responsive opacity-point-2 icon-width-height align-center" alt="drag">
                    </div>
                    <div class="col-md-1 col-lg-1 padding-left-0Perc">
                      <div class="align-center">
                        <div class="element-index-circle-width-height background-color-orange roundered-corner displayFlex" :class="{'background-color-red': !isActiveCurrentAction(actionObj)}">
                          <div class="element-index-font-style widthInherit fontSize17px marginTop2perc fontSize14px">
                              {{index + 1}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-7 col-lg-7 cursor-pointer text-align-left padding-left-0Perc padding-right-0Perc orange-text-color element-name-text-size element-name-style" :class="{'text-color-red': !isActiveCurrentAction(actionObj)}">
                      {{isComingFromCreate ? actionObj.ActionTitle : actionObj.ActionName + getActionVersion(actionObj)}}
                    </div>
                    <div class="col-md-2 col-lg-2">
                      <img src= "../../../assets/images/delete.svg" class="cursor-pointer img-responsive opacity-point-5 icon-width-height align-center" alt="delete" @click="performUserAction($event, 'delete', actionObj)">
                    </div>
                  </div>
                </transition-group>
              </draggable>
          </div>
        </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postfixString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation=""></confirmation-alert> -->
  </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
// import { dmAdminUtils } from '@/utils/dmAdminUtils'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import { leapsActionService } from '@/server-util/leaps-action-service'
import { Typeahead } from 'uiv'
import { find, findIndex, isObject, forEach, filter } from 'lodash'
export default {
  props: ['serverChallengeActions', 'isComingFromCreate'],
  name: 'challenge-action-association',
  created () {
    this.getLeapsActionList()
    this.setDefaultValues()
  },
  data: function () {
    return {
      notActiveAssocitedRowsFound: false,
      autoCompleteVisible: false,
      constants: constants,
      showConfirmationBox: false,
      prefixString: 'Are you sure you want to delete ',
      postfixString: '?',
      showAlertDialog: false,
      errorMsg: '',
      challengeActions: [],
      activeActionCount: 0,
      selectedActionObj: null
    }
  },
  methods: {
    isActiveCurrentAction: function (actionObj) {
      const foundObj = find(this.getGlobalActionList, (obj) => {
        return obj.ActionLibraryId === actionObj.ActionLibraryId
      })
      if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
        if (!foundObj.IsActive || this.notActiveAssocitedRowsFound) {
          this.notActiveAssocitedRowsFound = true
        }
        return foundObj.IsActive
      }
      return false
    },
    emitValuesToParent: function () {
      var objToReturn = {
        operationName: 'update-associated-actions-array',
        challengeActions: this.challengeActions
      }
      this.$emit('updateValues', objToReturn)
    },
    performUserAction: function (event, operationName, selectedObj) {
      switch (operationName) {
        case 'open-action-library-page':
          localStorage.setItem('selectedSubMenu', 44)
          localStorage.setItem('selectedMenu', 9)
          this.$store.state.hightLightOptionExplictly = true
          // this.$router.push('/actionlibrary?openCreatePopUp=' + true)
          let routeData = this.$router.resolve({name: 'LeapsAction', query: {openCreatePopUp: 'true'}})
          window.open(routeData.href, '_blank')
          break
        case 'delete':
          const foundIndex = findIndex(this.challengeActions, (obj) => {
            return selectedObj.ActionLibraryId === obj.ActionLibraryId
          })
          if (foundIndex > -1) {
            this.challengeActions.splice(foundIndex, 1)
          }
          forEach(this.challengeActions, (obj, index) => {
            obj.ActionIndex = index
          })
          this.emitValuesToParent()
          break
        case 'add':
          this.addIntoActionList()
          break
      }
    },
    addIntoActionList: function () {
      // console.log('this.selectedActionObj: ' + JSON.stringify(this.selectedActionObj) + ' isComingFromCreate: ' + this.isComingFromCreate)
      if (this.selectedActionObj !== undefined && this.selectedActionObj !== 'undefined' && this.selectedActionObj !== null && this.selectedActionObj !== 'null' && this.selectedActionObj !== '' && isObject(this.selectedActionObj)) {
        const foundObj = find(this.challengeActions, (obj) => {
          return obj.ActionLibraryId === this.selectedActionObj.ActionLibraryId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          this.showAlertDialog = true
          this.errorMsg = '\'' + this.selectedActionObj.ActionName + '\' action already present in the list.'
        } else {
          /*
            AK: Added ActionTitle and ActionName both as using same component for Create and Update operation.
            As because of different variable convension used for Create and Update operations at API end, Passing both values
            to server.
          */
          var objToPush = {
            ActionIndex: this.challengeActions.length,
            ActionLibraryId: this.selectedActionObj.ActionLibraryId,
            ActionTitle: this.selectedActionObj.ActionName,
            ActionName: this.selectedActionObj.ActionName
          }
          this.challengeActions.push(objToPush)
          this.selectedActionObj = null
          this.emitValuesToParent()
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid action.'
      }
    },
    getLeapsActionList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        leapsActionService
          .getLeapsActionList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              storeObj.state.leapsActionList = responseObj.data
              forEach(storeObj.state.leapsActionList, (obj) => {
                obj.ActionSearchbleField = obj.ActionName
                if (obj.ActionVersion !== undefined && obj.ActionVersion !== 'undefined' && obj.ActionVersion !== null && obj.ActionVersion !== 'null' && obj.ActionVersion !== '' && obj.ActionVersion.trim().length !== 0) {
                  obj.ActionSearchbleField += ' ' + obj.ActionVersion
                }
              })
              const activeActionList = filter(storeObj.state.leapsActionList, (obj) => {
                return obj.IsActive
              })
              this.activeActionCount = activeActionList.length
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS ACTION LIST'
        )
      }
    },
    increaseComponentHeight: function (evt) {
      this.autoCompleteVisible = true
    },
    decreaseComponentHeight: function (evt) {
      this.autoCompleteVisible = false
    },
    setDefaultValues: function () {
      if (this.serverChallengeActions !== undefined && this.serverChallengeActions !== 'undefined' && this.serverChallengeActions !== null && this.serverChallengeActions !== 'null' && this.serverChallengeActions !== '' && this.serverChallengeActions.length > 0) {
        this.challengeActions = this.serverChallengeActions
      }
      window.onfocus = () => {
        this.getLeapsActionList()
      }
    },
    getActionVersion: function (currActionObj) {
      const foundObj = find(this.$store.state.leapsActionList, (obj) => {
        return obj.ActionLibraryId === currActionObj.ActionLibraryId
      })
      if ((foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') && (foundObj.ActionVersion !== undefined && foundObj.ActionVersion !== 'undefined' && foundObj.ActionVersion !== null && foundObj.ActionVersion !== 'null' && foundObj.ActionVersion !== '' && foundObj.ActionVersion.trim().length !== 0)) {
        return ' [' + foundObj.ActionVersion + ']'
      }
      return ''
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of Confirmation overlay
      this.showConfirmationBox = value
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'loader': Loader,
    draggable,
    Typeahead
  },
  watch: {},
  computed: {
    challengeActionValue: {
      get: function () {
        return this.challengeActions
      },
      set: function (newValue) {
        forEach(newValue, (obj, index) => {
          obj.ActionIndex = index
        })
        this.challengeActions = newValue
        this.emitValuesToParent()
      }
    },
    getActiveGlobalActionList: {
      get: function () {
        // console.log('this.$store.state.leapsActionList: ' + JSON.stringify(this.$store.state.leapsActionList))
        const actionList = this.$store.state.leapsActionList
        const activeActionList = filter(actionList, (obj) => {
          return obj.IsActive
        })
        this.activeActionCount = activeActionList.length
        forEach(activeActionList, (obj) => {
          if (obj.ActionVersion !== undefined && obj.ActionVersion !== 'undefined' && obj.ActionVersion !== null && obj.ActionVersion !== 'null' && obj.ActionVersion !== '' && obj.ActionVersion.trim().length !== 0) {
            obj.CustomActionName = obj.ActionName + ' [' + obj.ActionVersion + ']'
          } else {
            obj.CustomActionName = obj.ActionName
          }
          return obj.CustomActionName
        })
        return activeActionList
      },
      set: function (newValue) {
        this.$store.state.leapsActionList = newValue
      }
    },
    getGlobalActionList: {
      get: function () {
        return this.$store.state.leapsActionList
      },
      set: function (newValue) {
        this.$store.state.leapsActionList = newValue
      }
    }
  }
}
</script>
<style scoped>
.text-color-blue {
  color: blue;
}
.margin-bottom-1Perc {
  margin-bottom: 1%;
}
.font-size-12px {
  font-size: 12px;
}
.min-height-25px {
  min-height: 25px;
}
.margin-left-15px {
  margin-left: 15px;
}
.padding-left-15px {
  padding-left: 15px;
}
.white-BG {
  background-color: #ffffff;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid #aaa;
}
.border-color-red {
  border: 1px solid red;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.height300{
  min-height: 300px;
  overflow-y: scroll;
}
.border-left-grey {
  border-left: 1px solid #ddd;
}
.heightAuto{
  height: auto;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-default {
  cursor: default;
}
.opacity-point-2 {
  opacity: 0.5;
}
.opacity-point-5 {
  opacity: 0.9;
}
.padding-bottom-2perc {
    padding-bottom: 2%;
}
.padding-top-2perc {
    padding-top: 2%;
}
.left-icon-div {
  float: left;
  width: 5%;
}
.right-element-duration-div {
  float: right;
  width: 83%;
}
.middle-element-type-name-div {
  margin: 0 auto;
}
.element-type-font-style {
  font-weight: bold;
}
.element-icon-width-height {
  width: 23px;
  height: 14px;
}
.include-in-progress-width-height {
  width: 20px;
  height: 20px;
}
.padding-top-5px {
  padding-top: 5px;
}
.element-index-font-style {
  font-size: 19px;
  color: #ffffff;
}
.element-index-circle-width-height {
  width: 20px;
  height: 20px;
}
.roundered-corner {
  border-radius: 10px;
}
.challenge-action-association {
  width: 100%;
}
.element-name-style {
  font-weight: lighter;
}
.bottom-dotted-border {
  border-bottom: 1px dotted #aaa;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-Top-Bottom-1Point5Perc {
  padding-top: 1.5%;
  padding-bottom: 1.5%;
}
.icon-width-height {
  width: 18px;
  height: 22px;
}
.red-color-border {
  border: 1px solid red;
}
.green-color-border {
  border: 1px solid green;
}
.align-center {
  margin: 0 auto !important;
}
.text-align-left {
  text-align: left;
}
.element-name-text-size {
  font-size: 14px;
}
.orange-text-color {
  color: #f39c12;
}
.text-color-red {
  color: red;
}
.border-red{
  border: 1px solid red !important;
}
.border-yellow{
  border: 3px solid #efe700 !important;
}
.padding-right-0Perc{
  padding-right: 0%;
}
.padding-left-0Perc{
  padding-left: 0%;
}
.width-5Perc{
  width: 5%;
}
.float-left{
  float: left;
}
.margin-5Perc {
  margin:5%;
}
.tooltip1 {
    position: relative;
    /* display: inline-block; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    /* width: 133px; */
    width: -webkit-fill-available;
    background-color: #696969;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0.5px;
    position: absolute;
    z-index: 1;
    top: 150%;
    left: 140%;
    margin-left: -60px;
    font-size: 11px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.margin-right-0px {
  margin-right: 0px;
}
.margin-0px {
  margin: 0px;
}
.margin-left-2px {
  margin-left: 2px;
}
.displayFlex {
  display: flex;
  align-items: center;
}
.fontSize12px {
  font-size: 12px !important;
}
.fontSize14px {
  font-size: 14px !important;
}
.fontSize17px {
  font-size: 17px;
}
.widthInherit {
  width: inherit;
}
.marginTop2perc {
  margin-top:2%;
}
.background-color-orange {
  background-color: #f39c12;
}
.background-color-red {
  background-color: red;
}
.font-weight-bold {
  font-weight: 800;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}
.icon-addon {
  position: relative;
  color: #555;
  display: block;
}
.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}
.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 7px 16px 6px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
</style>


// WEBPACK FOOTER //
// src/components/leaps/challenges/ChallengeActionAssociation.vue